import { hasDefinedValue } from '@sgme/fp';
import { TagOption } from 'components/shared/Tags/model';

export function definedTagValue<T>(tag: TagOption<T>) {
  return hasDefinedValue('rawValue')(tag);
}
